import "../style.scss";

import { FormGroup } from "@mui/material";
import IosSwitch from "components/shared/IosSwitch";
import StyledCheckbox from "components/shared/StyledCheckbox";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const formGroupStyles = {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "nowrap",
};

interface SwitchFormComponentProps {
    label: string;
    /** Specific color for the label */
    labelColor?: string;
    /** Parenthesis label information */
    labelInfo?: string;
    control: any;
    controlName: string;
    error?: any;
    required?: boolean;
    disabled?: boolean;
    /** Specify if you wan a visual checkbox instead of switch */
    checkbox?: boolean;
}

const SwitchFormComponent = (props: SwitchFormComponentProps) => {
    const {
        label,
        labelColor,
        labelInfo,
        control,
        controlName,
        error,
        required,
        disabled = false,
        checkbox = false,
    } = props;
    const [t] = useTranslation();

    return (
        <div className="form-component">
            <Controller
                name={controlName}
                control={control}
                rules={{
                    required: required ? t("NewElement.Required") : undefined,
                }}
                render={({ field }) => {
                    return (
                        <FormGroup
                            sx={{ ...formGroupStyles, alignItems: "center" }}
                            {...field}
                            className="payments-methods"
                        >
                            <label
                                className="form-component-label"
                                htmlFor={controlName}
                                style={{ padding: "0", color: labelColor }}
                            >
                                {label} {labelInfo && <span className="form-component-label-info">({labelInfo})</span>}
                            </label>
                            {checkbox ? (
                                <StyledCheckbox {...field} checked={field.value} id="bypassIbanValidation" />
                            ) : (
                                <IosSwitch {...field} checked={field.value} id="bypassIbanValidation" />
                            )}
                        </FormGroup>
                    );
                }}
            />
        </div>
    );
};

export default SwitchFormComponent;
